import { Box, Chip, Grid, Typography } from '@mui/material';
import { gridContainer, infoGridItem } from '../Styles/CustodianContactDetailsStyles';
import { labelText, labelTitle } from '../../../assets/styles/appStyles';
import EntityCustodianDetailsViewModel from '../../../Models/custodian/entity-custodian-details-viewmodel';
import ServeInformation from './Department/Components/ServeInformation';
import ServePreferencesInfo from './Department/Components/ServePreference/ServePreferencesInfo';
import BillingInfoDetails from './Billing/BillingInfoDetails';
import FollowUpMethodDetails from './Department/Components/FollowUpMethodDetails';
import OtherInfoDetails from './Department/Components/OtherInfoDetails';

export default function EntityCustodianDetails({
  custodianDetails,
}: Readonly<{
  custodianDetails: EntityCustodianDetailsViewModel;
}>) {
  return (
    <>
      <Grid rowSpacing={3} container sx={gridContainer} spacing={2}>
        <Grid container item rowSpacing={3}>
          <Grid item xs={6} sx={infoGridItem}>
            <Typography align="left" sx={labelTitle} mb={'5px'}>
              Record Type
            </Typography>
            <Grid container spacing={1}>
              {custodianDetails?.recordTypes.map((p) => (
                <Grid item key={p.id}>
                  <Chip sx={{ color: 'white' }} label={p.name} color="primary" variant="filled" />
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={6} sx={infoGridItem}>
            <Typography sx={labelTitle}>Notes</Typography>
            <Box>
              <Typography sx={labelText}>{custodianDetails?.recordTypeNotes ?? '-'}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid rowSpacing={3} container sx={gridContainer} spacing={2}>
        <Grid container item rowSpacing={3}>
          <Grid item xs={6} sx={infoGridItem}>
            <Typography align="left" sx={labelTitle} mb={'5px'}>
              Order Type
            </Typography>
            <Grid container spacing={1}>
              <Grid item>
                <Chip sx={{ color: 'white' }} label={custodianDetails?.orderTypeName} color="primary" variant="filled" />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} sx={infoGridItem}>
            <Typography sx={labelTitle}>Notes</Typography>
            <Box>
              <Typography sx={labelText}>{custodianDetails?.orderTypeNotes ?? '-'}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <FollowUpMethodDetails
        custodianDetails={custodianDetails}
      />
      <OtherInfoDetails
        otherInfo={custodianDetails?.entityMetric}
      />
      <ServeInformation
        departmentDaysAvailable={custodianDetails?.daysAvailable ?? []}
        departmentServeMethods={custodianDetails?.serveMethods ?? []}
        roiMethods={custodianDetails?.roiMethods ?? []}
        serveMethodNotes={custodianDetails?.serveMethodNotes}
        roiMethodNotes={custodianDetails?.roiMethodNotes}
      />
      <ServePreferencesInfo
        servePreferences={custodianDetails?.servePreferences}
        files={custodianDetails?.files ?? []}
      />
      <BillingInfoDetails
        custodian={custodianDetails}
      />
    </>
  );
}
